import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { IItemConfigSet } from "../interfaces/iconfigurationset";
import { ICountry } from "../interfaces/icountry";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";

@Injectable()
export class CountryInformationService extends BaseService {
    constructor(http: HttpClient,
        private applicationSettings: ApplicationSettingsService,
        authService: AuthService,
        toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    /**
     * Gets country information for a particular country
     * @param countryCode The country code to retrieve the information for
     */
    getCountryInformation(countryCode: String): Observable<IItemConfigSet> {
        return super.get(`${this.applicationSettings.apiUrl}CountryInformation/${countryCode}`);
    }

    /**
     * Gets countries that have category detail associated to them
     */
    getCountriesWithCategoryDetail(): Observable<ICountry[]> {
        const url = `${this.applicationSettings.apiUrl}CountriesWithItemConfigDetail`;        
        return super.get(url);
    }

    getCountriesForPublicPortal(): Observable<ICountry[]> {
       const url = `${this.applicationSettings.apiUrl}CountriesWithItemConfigDetail/GetAllCountries`;       
       return super.get(url);
    }
}